import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import kotlinx.browser.window
import org.jetbrains.skiko.wasm.onWasmReady
import team.platforma.materialextension.App
import team.platforma.materialextension.telegramOneTap.TgSocial

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        saveRedirectDataToLocalStorage()
        CanvasBasedWindow(canvasElementId = "ComposeTarget") {
            App()
        }
    }
}

private fun saveRedirectDataToLocalStorage() {

    val href = window.location.href
    console.log("1")
    console.log("is it answer:${href != TgSocial().redirectUrl}")
    if (href != "http://localhost:8080/") {
        if (href != TgSocial().redirectUrl) {

            // try save vk redirect data
            try {
                val substring = href.substringAfter('#').substringAfter('=')
                if (substring.isNotEmpty()) {
//                    val jsonMap = substring.split("&").associate {
//                        val parts = it.split("=", limit = 2)
//                        val key = parts[0]
//                        val value = if (parts.size > 1) parts[1] else ""
//                        key to value
//                    }
//
//                    val jsonString = substring
//                        jsonMap.entries.joinToString(",", "{", "}") { (key, value) ->
//                        "\"$key\": \"${value}\""
//                    }
                    console.log(4)
                    console.log("Data substring: ${substring}")
                    val parsedString = decodeTgAuthResult(substring)
                    console.log(parsedString)
//                    Json.decodeFromString<VKIDResponse>(json)!!
                    window.localStorage.setItem(TgSocial().localStorageVkKey, parsedString)
                    window.location.assign(TgSocial().originUrl)
//                    window.location.href = TgSocial().originUrl
//                    if (TgSocial().redirectUrl == "http://localhost") {
//                        window.location.href = "http://localhost:8080"
//                    } else {
//                        window.location.href = TgSocial().redirectUrl
//                    }
                }
            } catch (_: Exception) {
                // nothing to do
            }
        }
    }
}

fun decodeTgAuthResult(encoded: String): String {
    var base64 = encoded.replace('-', '+').replace('_', '/')

    // Добавляем padding, если нужно
    val padding = (4 - base64.length % 4) % 4
    base64 += "=".repeat(padding)

    // Декодируем с помощью atob
    val jsonString = try {
        window.atob(base64)
    } catch (e: Throwable) {
        throw IllegalArgumentException(
            "Невозможно раскодировать строку: неправильный формат Base64",
            e
        )
    }

    // Парсим JSON
    val json = JSON.parse<dynamic>(jsonString)

    // Красиво форматируем
    return JSON.stringify(json, space = 4)
}
